import API_BACK from "../lib/axiosBack";
// import API from "../lib/axios";
import { BalanceResponse } from "../types/user";
import { logoutCompletely } from "../utils/logoutCompletely";

export const getBalance = async (): Promise<number> => {
  try {
    const response = await API_BACK.get<BalanceResponse>("/balance/provider", {
      // const response = await API.get<BalanceResponse>("/back/balance/provider", {
      params: { cryptoCurrency: "USDT" },
    });

    return response.data.balanceInCrypto;
  } catch (error: any) {
    const status = error?.response?.status;

    if (status === 401) {
      console.warn("🔒 User not authenticated (401)");
      logoutCompletely();
    } else if (status === 404) {
      console.error("❌ Provider not found (404)");
    } else if (status === 500) {
      console.error("💥 Internal server error (500)");
    } else {
      console.error("❌ Unknown error occurred while fetching balance:", error);
    }

    throw error;
  }
};
